import { render, staticRenderFns } from "./Koulutukset.vue?vue&type=template&id=7b40f9f1&"
import script from "./Koulutukset.vue?vue&type=script&lang=js&"
export * from "./Koulutukset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports